import { Box, Typography } from "@mui/joy";
import NewsList from "../components/news/list/NewsList";
import { newsArticles } from "../components/news/mockData";

function NewsApp() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        padding: "20px",
        height: "100%",
        overflow: "auto", // Enable vertical scrolling
      }}
    >
      <Box
        sx={{
          maxWidth: "600px",
          width: "100%",
          margin: "0 auto", // Center content
        }}
      >
        <Typography level="h1" sx={{ mb: 3 }}>Wine News</Typography>
        <NewsList articles={newsArticles} />
      </Box>
    </Box>
  );
}

export default NewsApp;